import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import locale from 'element-ui/lib/locale';
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui lang
import vantEnLocale from 'vant/lib/locale/lang/en-US'
import vantZhLocale from 'vant/lib/locale/lang/zh-CN'
import VantLocale from 'vant/lib/locale'
import enLocale from './en'
import zhLocale from './zh'
//
const contextEN = require.context('@/page', true, /\.en.js$/);
const contextZH = require.context('@/page', true, /\.zh.js$/);
function moduleStore(context){
  const moduleStores = {};
  context.keys().forEach(key => {
    const fileName = key.split('/');
    const size = fileName.length;
    const modName = fileName[size-1].split('.')[0];
    const fileModule = context(key).default;
    moduleStores[modName] = {
      ...fileModule
    };
  });
  return moduleStores
}
let moduleEN = moduleStore(contextEN)
let moduleZH = moduleStore(contextZH)
//
const messages = {
  en: {
    ...moduleEN,
    ...enLocale,
    ...elementEnLocale,
    ...vantEnLocale
  },
  zh: {
    ...moduleZH,
    ...zhLocale,
    ...elementZhLocale,
    ...vantZhLocale
  }
}
Vue.use(VueI18n)
const i18n = new VueI18n({
  // set locale
  // options: en | zh
  locale: Cookies.get('language') || 'zh',
  // set locale messages
  messages,
  silentTranslationWarn: true
})
locale.i18n((key, value) => i18n.t(key, value))

// 设置Vant locale
function setVantLocale(lang) {
  VantLocale.use(lang === 'zh' ? vantZhLocale : vantEnLocale);
}
setVantLocale(i18n.locale);

// 监听i18n语言切换，同步更新Vant locale
i18n._vm && i18n._vm.$watch('locale', function(val) {
  setVantLocale(val);
});

export default i18n



// WEBPACK FOOTER //
// ./src/lang/index.js